export default {
  inserted: function (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center'})
  }
}